import React, { useEffect, useRef } from 'react';
import { FileText } from 'lucide-react';

interface TaskFormDescriptionProps {
  value: string;
  onChange: (value: string) => void;
  onKeyDown?: (e: React.KeyboardEvent<HTMLTextAreaElement>) => void;
  isEditMode?: boolean;
}

export const TaskFormDescription: React.FC<TaskFormDescriptionProps> = ({
  value,
  onChange,
  onKeyDown,
  isEditMode = false
}) => {
  const descriptionRef = useRef<HTMLTextAreaElement>(null);
  
  // Auto-adjust textarea height for descriptions in edit mode
  useEffect(() => {
    if (isEditMode && descriptionRef.current) {
      descriptionRef.current.style.height = 'auto';
      descriptionRef.current.style.height = `${descriptionRef.current.scrollHeight}px`;
    }
  }, [isEditMode, value]);

  // Auto-adjust textarea height for descriptions in new task mode
  useEffect(() => {
    if (!isEditMode && descriptionRef.current) {
      descriptionRef.current.style.height = 'auto';
      descriptionRef.current.style.height = `${descriptionRef.current.scrollHeight}px`;
    }
  }, [isEditMode, value]);

  return (
    <div className="relative">
      <div className="relative">
        <FileText size={14} className="text-gray-500 absolute left-0 top-1 flex-shrink-0" />
        <textarea
          ref={descriptionRef}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onKeyDown={onKeyDown}
          placeholder="Add description..."
          className="w-full pl-5 bg-transparent text-gray-600 placeholder-gray-400 focus:outline-none resize-none"
          rows={2}
          style={{
            overflow: 'auto',
            height: 'auto',
            maxHeight: '250px',
          }}
        />
      </div>
    </div>
  );
};